import request from '@/utils/request'

//Login
export function getUSTripDetailsApi(page) {
  return request({ url: 'vgetustripstatus', method: 'post', data: {'page': page} })
} 